// Admin SearchBar.

import React from 'react';
import { Stack, Box } from '@mui/material';
import Config from '../../lib/Config';
import { useState, useEffect } from 'react';
import '../../assets/style/fonts.css';
// import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Util from '../../lib/Util';
import { useForm, Controller, formState } from 'react-hook-form';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import UIString from '../../assets/content/UIString';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';


export default (props) => {

    const lang = Util.get_lang();
    const [keyword,setKeyword] = useState('');
    useEffect(() => { console.log('search bar keyword: ',props.keyword);
        if( props.keyword != undefined ){
            setKeyword(props.keyword);
        }
    }, [props.keyword]);

/*
    // Define Yup schema
    const schema = Yup.object().shape({
        login: Yup.object().shape({
            // corp_code: Yup.string().matches(/^([0-9a-zA-Z]{6,22})$/,UIString[lang].INVALID_CORP_CODE_FORMAT).required(UIString[lang].CORP_CODE_IS_REQUIRED),
            email: Yup.string().email(UIString[lang].INVALID_EMAIL_FORMAT).required(UIString[lang].EMAIL_IS_REQUIRED),
            password: Yup.string().min(6, UIString[lang].INVALID_PASSWORD_FORMAT).max(40, UIString[lang].INVALID_PASSWORD_FORMAT).required(UIString[lang].PASSWORD_IS_REQUIRED),
        }),
    });
    */

/*
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
*/


    const onSubmit = (e) => {
        /*
                fetch('/ko/api/v1/admin/auth/login')
          .then(response => response.json())
          .then(data => console.log(data));
        
        
        
          return;*/
     
       //alert('Form data:', keyword);
       props.start_search(keyword);

    }


    function reset_search(){
        setKeyword('');
        props.reset_search();
    }


    return (
        <Box sx={{ textAlign: 'left',height:'48px !important' }}>
            <form method='POST' onSubmit={(e)=>{e.preventDefault();props.start_search(keyword.trim());}} >

                    <TextField
                        
                        //error={!errors.login?.email}
                        //helperText={errors.login?.email ? errors.login.email.message : ''}
                        placeholder={UIString[lang].SEARCH}
                        variant="outlined"
                        style={{ height: '42px', width: '100%', marginBottom: '28px',borderRadius:'50%' }}
                        value={keyword}
                        onChange={(v)=>{ if(v.target.value.length > 100){return;} setKeyword(v.target.value);}}
                    

                        InputProps={{
                            sx: {
                                
                                height: '42px',
                                fontSize: '13px', backgroundColor: '#00ff00',
                                '&.MuiOutlinedInput-root': {
                                    backgroundColor: '#f8f8f8',  // Set grey background
                                    '& fieldset': {
                                        border: 'none',              // Remove border even when focused
                                    },
                                    '&:hover fieldset': {
                                        border: 'none',              // Remove border on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: 'none',              // Remove border when focused
                                    },
                                },
                                '::placeholder': {
                                    fontSize: '12px',              // Set placeholder font size
                                },
                            },

                            startAdornment: (
                                <InputAdornment position="start" sx={{ paddingRight: '8px' }}>
                                    <IconButton
                                        tabIndex={-1}
                                        edge="end"
                                        sx={{ padding: 0 }} // Optional: adjust icon padding
                                    >
                                        <SearchIcon sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="start" sx={{ paddingRight: '8px' }}>
                                    <IconButton
                                        tabIndex={-1}
                                        edge="end"
                                        sx={{ padding: 0 }} // Optional: adjust icon padding
                                        onClick={()=>{reset_search();}}
                                    >
                                        <CloseIcon sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                </InputAdornment>
                            ),

                        }}
                        sx={{
                            borderRadius:'50%',
                            "& .MuiInputBase-root": {
                                "&:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 100px white inset", // Background color
                                    WebkitTextFillColor: "black", // Text color
                                    WebkitTextFillColor: "black", // Text color
                                    backgroundColor: "#ffffff !important", // Explicit background reset
                                },
                            },

                            backgroundColor: "#ffffff !important",
                            "& .MuiInputBase-root": {

                                "&:-webkit-autofill": {

                                    WebkitBoxShadow: "0 0 0 100px white inset", // Background color
                                    WebkitTextFillColor: "black", // Text color
                                },
                            },

                            '& .MuiInputBase-input::placeholder': {
                                fontSize: '12px',                // Ensure placeholder font size
                            },

                            "& .MuiInputBase-root": {
                                height: "42px", // Fixed height for the input container
                                paddingTop: "0", // Reset padding to prevent autofill changes
                                paddingBottom: "0",borderRadius:'11px',paddingRight:'8px',
                            },
                            "& input": {
                                height: "100%", // Ensure the inner input spans the full height
                                paddingTop: "0", // Reset padding to prevent autofill changes
                                paddingBottom: "0",
                                boxSizing: "border-box", // Ensure consistent box model
                                paddingTop: "0", // Reset padding to prevent autofill changes
                                paddingBottom: "0",paddingLeft:'11px',
                            },
                            "& .MuiInputBase-root:-webkit-autofill": {
                                WebkitBoxShadow: "0 0 0 100px white inset", // Remove background color
                                WebkitTextFillColor: "black", // Text color
                                paddingTop: "0", // Reset padding to prevent autofill changes
                                paddingBottom: "0",
                            },
                            "& .MuiInputBase-input": {
                                paddingTop: "0", // Reset padding to prevent autofill changes
                                paddingBottom: "0",
                            },
                        }}

                    />
              
            </form>
        </Box>
    );

}